export enum AUTHORSORT {
  NAMEASC = 'author-name-asc',
  NAMEDESC = 'author-name-desc',
  LOCALSCOREASC = 'author-score-local-score-asc',
  LOCALSCOREDESC = 'author-score-local-score-desc',
  GLOBALSCOREASC = 'author-score-global-score-asc',
  GLOBALSCOREDESC = 'author-score-global-score-desc',
  ARTICLECOUNTASC = 'article-count-asc',
  ARTICLECOUNTDESC = 'article-count-desc',
}
